export function getSongElementId(songId: string) {
  return `song-${songId}`;
}
